import React from "react";
import APIClient from "../APIClient";
import {keycloakClient as client} from "../../../../ui/hooks/useOidcClient";
import useCustomerContext from "../../../../customers/hooks/useCustomerContext";

export default function useAPIClient(baseUri?: string, skipAuth?: boolean): APIClient {
    skipAuth = skipAuth !== undefined ? skipAuth : baseUri === undefined;
    const {languageCode} = useCustomerContext();

    return React.useMemo(() => new APIClient(baseUri, skipAuth, client.token, async () => {
        if (!client.didInitialize) {
            const isInit = await client.init({
                onLoad: "check-sso",
                responseMode: "query"
            });

            if (!isInit) {
                return undefined;
            }
        }

        if (client.refreshToken) {
            try {
                await client.updateToken();
            } catch (e) {
                await client.logout();
            }
        }

        return client.token;
    }, languageCode), []);
}
